import { render } from "./HomeAdmin.vue?vue&type=template&id=70a6426c&scoped=true"
const script = {}

import "./HomeAdmin.vue?vue&type=style&index=0&id=70a6426c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a6426c"]])

export default __exports__